import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-improvements',
  templateUrl: './improvements.component.html',
  styleUrls: ['./improvements.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImprovementsComponent implements OnInit {
  errorWarningData: any = {};
  @Input() MatterConveyancingDetailsForm: FormGroup;
  propertyTypeLookupsData: any[];
  sub: Subscription;

  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  constructor() {}

  ngOnInit(): void {}
}
